import { createSelector, createSlice } from '@reduxjs/toolkit';
import { FORM_TYPES } from '../../../types/paramsConfig.js';
import { clearResetPasswordInput, refreshResetPasswordState, } from '../../../views/ResetPassword/resetPasswordSlice.js';
import { clearRegistrationInputs } from '../../../views/Registration/registrationSlice.js';
import { clearLoginInputs } from '../../../views/Login/loginSlice.js';
import { clearAuthError } from '../../core/authError/authErrorSlice.js';
import { clearActiveView, clearActiveWrapper, setActiveView, setActiveWrapper, WRAPPER_TYPES, activeViewSelector, isViewActiveSelector, } from '../../core/wrapperContext/wrapperContextSlice.js';
export const initialModalState = {
    isGDPRModalActive: false,
};
export const modalSlice = createSlice({
    name: 'modal',
    initialState: initialModalState,
    reducers: {
        setGDPRModalActive: (state, actions) => {
            state.isGDPRModalActive = actions.payload;
        },
    },
});
export const showModalThunk = (formType) => async (dispatch) => {
    console.log('showModalThunk: ', formType);
    dispatch(setActiveWrapper(WRAPPER_TYPES.MODAL));
    dispatch(setActiveView(formType));
};
export const closeModalThunk = () => async (dispatch) => {
    dispatch(clearLoginInputs());
    dispatch(clearRegistrationInputs());
    dispatch(clearResetPasswordInput());
    dispatch(refreshResetPasswordState(false));
    dispatch(clearAuthError());
    dispatch(clearActiveWrapper());
    dispatch(clearActiveView());
};
export const modalActions = modalSlice.actions;
const loginRegistrationModalState = (state) => state.wrappers.modal;
/**
 * @deprecated Use activeViewSelector from wrapperContext instead
 */
export const activeModalTypeSelector = (state) => activeViewSelector(state);
/**
 * @deprecated Use isViewActiveSelector from wrapperContext instead
 */
export const isModalVisible = (modalType) => isViewActiveSelector(modalType);
export const isExternalModalVisibleSelector = createSelector((state) => activeViewSelector(state), (state) => state.forms.registration, (activeView, registrationState) => {
    return (activeView === FORM_TYPES.REGISTRATION &&
        registrationState.showRegistrationSuccessfulModal === true);
});
export const isGDPRModalActiveSelector = createSelector(loginRegistrationModalState, (state) => state?.isGDPRModalActive);
export default modalSlice.reducer;
//# sourceMappingURL=modalSlice.js.map